// @flow
import * as React from "react";
import Slider from "react-slick";
import sliderimage from "../../Assets/images/2.webp";
import bannerImage from "../../Assets/images/1.webp";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "./Api/Api";
import { Link } from "react-router-dom";

export const SliderSection = () => {
  const [bannerList, setBannerList] = useState([]);
  const [leftBanner, setLeftBanner] = useState(null);
  const [rightBanner, setRightBanner] = useState(null);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const responseGlobal = await axios.post(
        BASE_URL,
        {},
        {
          headers: {
            cmd: "banner",
            "Content-Type": "application/json",
          },
        }
      );
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data;
        const sliderList = data?.dt?.filter((data) => data?.Position === 0);
        setBannerList(sliderList);
        setLeftBanner(data?.dt?.filter((data) => data?.Position === 1));
        setRightBanner(data?.dt?.filter((data) => data?.Position === 2));
      } else {
        throw new Error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };
  const settings = {
    dots: true,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 3,
    prevArrow: <></>,
    nextArrow: <></>,
  };
  return (
    <div className="row">
      <div className="col-12 col-lg-12 ">
        <Slider {...settings} className="active:outlin-none rounded ">
          {bannerList?.map((slider, index) => (
            <div key={index} className="w-full ">
              <Link to={slider.link}>
                <img
                  src={`https://api.taab30.com${slider.img || ""}`}
                  alt={"slider"}
                  className="w-100  rounded "
                />
              </Link>
            </div>
          ))}
        </Slider>
      </div>
      {/* <div className="col-12 col-lg-4 row p-0 m-auto">
        <div className="col-12">
          <Link to={leftBanner?.[0].link}>
            <img
              alt=""
              className="w-100 box-shadow rounded-3 mb-3"
              src={`https://api.taab30.com${leftBanner?.[0]?.img || ""}`}
            />
          </Link>
        </div>
        <div className="col-12">
          <Link to={rightBanner?.[0]?.link}>
            <img
              alt=""
              className="w-100 box-shadow rounded-3 mb-3"
              src={`https://api.taab30.com${rightBanner?.[0]?.img || ""}`}
            />
          </Link>
        </div>
      </div> */}
    </div>
  );
};
